/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {FETCH_PORTFOLIO_CONTENTS_REQUEST, FETCH_PORTFOLIO_CONTENTS_SUCCESS, FETCH_PORTFOLIO_CONTENTS_FAILURE } from './PortfolioContentsType';
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";



export const fetchPortfolioContentDetailsRequest = () => {
  return {
    type: FETCH_PORTFOLIO_CONTENTS_REQUEST,
  };
};

export const fetchPortfolioContentDetailsSuccess = (portfolioContentDetails) => {
  return {
    type: FETCH_PORTFOLIO_CONTENTS_SUCCESS,
    payload: portfolioContentDetails,
  };
};

export const fetchPortfolioContentDetailsFailure = (error) => {
  return {
    type: FETCH_PORTFOLIO_CONTENTS_FAILURE,
    payload: error,
  };
};

export const fetchPortfolioContentDetails = (portfolioId, contenId) => {
  return async function (dispatch) {
    dispatch(fetchPortfolioContentDetailsRequest());
    try {
      const data = await APIManager.getPortfolioContentDetails(portfolioId, contenId);
      dispatch(fetchPortfolioContentDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchPortfolioContentDetailsFailure(error));
      dispatch(commonError(error, FETCH_PORTFOLIO_CONTENTS_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
